module.exports = __webpack_public_path__ + "img/invitation_code_icon.e9c7ca05.svg";